module.exports = {"id":"201529","name":"Marco Capuano","rating":"71","photo":"./data/images/photos/0/201529.png","club":{"name":"Crotone","logo":"./data/images/clubs/Crotone.png"},"positions":["DC","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoCapuano0.json
// module id = 2735
// module chunks = 0